function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { isItemEmbellishmentChangeProductionTimeConfirmationPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { cartItemsSelector, draftItemsSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { rebuildItem } from 'swag-client-common/redux/cart/cart.actions';
import { PRODUCTION_TIME_DRAWER } from 'swag-client-common/constants';
import { confirmEmbellishmentMethodChangeWithDefaultProductionTime } from '../../../redux/product/product.actions';
import { ItemEmbellishmentChangeProductionTimeConfirmationPopup as ItemEmbellishmentChangeProductionTimeConfirmationPopupComponent } from './item-embellishment-change-production-time-confirmation-popup';
const methodIdSelector = createSelector(popupParamsSelector, ({
  methodId
}) => methodId);
const isItemEditSelector = createSelector(popupParamsSelector, ({
  isItemEdit
}) => isItemEdit);
const itemIdSelector = createSelector(popupParamsSelector, ({
  itemId
}) => itemId);
const productionTimeIdSelector = createSelector(popupParamsSelector, ({
  productionTimeId
}) => productionTimeId);
const storageTypeSelector = createSelector(popupParamsSelector, ({
  storageType
}) => storageType);
const mapStateToProps = createStructuredSelector({
  open: isItemEmbellishmentChangeProductionTimeConfirmationPopupShownSelector,
  methodId: methodIdSelector,
  isItemEdit: isItemEditSelector,
  itemId: itemIdSelector,
  productionTimeId: productionTimeIdSelector,
  storageType: storageTypeSelector,
  item: createSelector(itemIdSelector, cartItemsSelector, draftItemsSelector, (itemId, items, draftItems) => {
    var _find, _ref;
    return (_find = (_ref = [...items, ...draftItems]) === null || _ref === void 0 ? void 0 : _ref.find(({
      _id
    }) => _id === itemId)) !== null && _find !== void 0 ? _find : {};
  })
});
const mapDispatchToProps = dispatch => ({
  onConfirm: methodId => {
    dispatch(hidePopup());
    dispatch(confirmEmbellishmentMethodChangeWithDefaultProductionTime(methodId));
  },
  onCancel: (itemId, storageType) => {
    dispatch(hidePopup());
    dispatch(showPopup({
      popup: PRODUCTION_TIME_DRAWER,
      itemId: itemId,
      storageType: storageType
    }));
  },
  onItemConfirm: (item, storageType, methodId, productionTimeId) => {
    dispatch(hidePopup());
    dispatch(rebuildItem(_objectSpread({}, item, {
      embellishmentMethod: methodId,
      prodTime: productionTimeId
    }), storageType));
  }
});
export const ItemEmbellishmentChangeProductionTimeConfirmationPopup = connect(mapStateToProps, mapDispatchToProps)(ItemEmbellishmentChangeProductionTimeConfirmationPopupComponent);